import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import ProjectList from 'components/ProjectList/ProjectList'
import Button from 'components/shared/Button/Button'
import PropTypes from 'prop-types'
import React from 'react'
import { withNamespaces } from 'react-i18next'

import './FeaturedProjects.scss'

const FeaturedProjects = ({ featured, locale, t, gtm = {} }) => {
  const { entities, loading } = featured
  const sendDataToGTM = useGTMDispatch()
  const handleClick = () =>
    sendDataToGTM({ ...gtm, label: 'Featured projects: explore all' })

  return (
    <div className="homepage-featured__projects-container">
      <ProjectList
        display={!loading}
        locale={locale}
        projects={Object.values(entities)}
        loading={loading}
        gtm={gtm}
      />
      <Button
        type="primary"
        text={t('homepage.featured.button')}
        href={`/${locale}/projects`}
        onClick={handleClick}
      />
    </div>
  )
}

FeaturedProjects.propTypes = {
  featured: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  gtm: PropTypes.object,
}

export { FeaturedProjects }

export default withNamespaces('translations')(FeaturedProjects)
